/**
 * @fileoverview キャラクターセクションの制御スクリプト
 * @description キャラクター選択・切り替え機能とスライダー制御を行います。
 *
 * @overview
 * - キャラクターセレクターボタンのクリックでコンテンツ切り替え
 * - アクティブなキャラクターのスライダー管理
 * - アクセシビリティ対応（aria-hidden属性）
 * - レスポンシブ対応（ウィンドウリサイズ時の再初期化）
 */

import {
	mountCharacterSlider,
	destroyCharacterSlider
} from './_slider.js';

/** キャラクターセレクターボタンの要素コレクション */
const selectors = document.querySelectorAll(
	'.p-home-character__selector-item:not(.is-placeholder)'
);

/** キャラクターコンテンツの要素コレクション */
const contents = document.querySelectorAll('.p-home-character__content');

/**
 * アクセシビリティ対応のためのaria-hidden属性を更新
 * @param {Element} active - アクティブなコンテンツ要素
 */
const updateAria = (active) => {
	contents.forEach(article => {
		article.setAttribute(
			'aria-hidden',
			String(article !== active)
		);
	});
};

/**
 * キャラクターコンテンツを切り替え
 * @param {string} target - 切り替え先のキャラクターID
 */
const switchCharacter = (target) => {
	const article = document.getElementById(`character-${target}`);
	if (!article) return;

	// 初期フラグを全体から剥がす（最初の1回だけ）
	contents.forEach(a => a.classList.remove('is-initial'));

	// セレクターボタンのアクティブ状態を更新
	selectors.forEach(btn => {
		btn.classList.toggle('is-active', btn.dataset.target === target);
	});

	// すべてのコンテンツを非アクティブに
	contents.forEach(a => a.classList.remove('is-active', 'is-fade'));

	// 既存のスライダーを破棄（単一インスタンス前提）
	destroyCharacterSlider();

	// 新しいコンテンツをアクティブに
	article.classList.add('is-active');
	requestAnimationFrame(() => article.classList.add('is-fade'));

	// アクセシビリティとスライダーを更新
	updateAria(article);
	mountCharacterSlider(article);
};

/**
 * DOMContentLoadedイベントで初期化処理を実行
 */
document.addEventListener('DOMContentLoaded', () => {
	// 初期表示のアクティブコンテンツを取得
	const initial = document.querySelector('.p-home-character__content.is-active');
	if (!initial) return;

	// 初期状態の設定
	updateAria(initial);
	initial.classList.add('is-initial');
	mountCharacterSlider(initial);

	// セレクターボタンにクリックイベントを追加
	selectors.forEach(btn => {
		btn.addEventListener('click', () => {
			const target = btn.dataset.target;
			if (target) switchCharacter(target);
		});
	});

	// ウィンドウリサイズ時にスライダーを再初期化
	let lastWidth = window.innerWidth;
	window.addEventListener('resize', () => {
		if (window.innerWidth === lastWidth) return;
		lastWidth = window.innerWidth;

		const active = document.querySelector('.p-home-character__content.is-active');
		if (!active) return;

		destroyCharacterSlider();
		mountCharacterSlider(active);
	});
});
